module.exports = __webpack_public_path__ + "static/img/tl_3@2x.d667b31d.png";